import { useCallback } from 'react';
import { Checkbox } from 'src/client/components/recruitments/Checkbox';
import { useRecruitmentListContext } from 'client/contexts/recruitments/RecruitmentList';
import { JobTask } from 'src/client/generated';

type Props = {
  jobTasks: JobTask[];
};

export const JobTaskList = ({ jobTasks }: Props) => {
  const {
    searchQueryParams: { jobTaskIds },
    dispatch,
  } = useRecruitmentListContext();

  const handleClickCheckbox = useCallback(
    (id: string) => {
      let newJobTaskIds = jobTaskIds ? Array.from(jobTaskIds) : [];

      if (jobTaskIds?.includes(id)) {
        newJobTaskIds = newJobTaskIds.filter((taskId) => taskId !== id);
      } else {
        newJobTaskIds.push(id);
      }

      dispatch({
        type: 'changeJobTaskIds',
        payload: { jobTaskIds: newJobTaskIds },
      });
    },
    [jobTaskIds],
  );

  const isChecked = (id: string) => {
    return jobTaskIds?.includes(id) || false;
  };

  return (
    <div className="my-6 mx-0">
      {jobTasks.length > 0 &&
        jobTasks.map(
          (task) =>
            task && (
              <div
                key={task.id}
                className="w-full inline-flex items-center justify-between pt-5 pb-4 border-b border-light-gray"
                onClick={() => handleClickCheckbox(task.id)}
                data-testid={`job-task-checkbox-${task.id}`}
              >
                <Checkbox label={task.name} checked={isChecked(task.id)} onClick={() => {}} />
                <div className="divider"></div>
              </div>
            ),
        )}
    </div>
  );
};
